export default {
  ActionsList:  [
    {value:"FlatRateShippingCostOverrideModel", text:"Shipping Price"},
    {value:"ChangeShippingNamingActionModel", text:"Title and Description"},
    {value:"CarrierServiceMarkupModel", text:"Markup Shipping Price"},
    {value:"RemoveShippingMethodActionModel", text:"Hide a Shipping Method", actionButtonText: "Hide a Shipping Method"},
    {value:"RemoveShippingOptionBasedOnAvailableOptions", text:"Hide multiple Shipping Methods", actionButtonText: "Hide multiple Shipping Methods"},
  ]  
}